import { Slider } from "@/components/ui/slider";
import {
  CellProps,
  isRangeControl,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsCellProps } from "@jsonforms/react";

export const SliderCell = (props: CellProps) => {
  const { data, id, enabled, schema, path, handleChange } = props;

  return (
    <div className="flex items-center gap-4">
      <Slider
        max={schema.maximum}
        min={schema.minimum}
        value={[data || schema.default]}
        onValueChange={([value]) => handleChange(path, value)}
        id={id}
        disabled={!enabled}
        aria-describedby={`${id}-description`}
      />
      <span className="min-w-[3ch]">{data || schema.default}</span>
    </div>
  );
};

export const sliderCellTester: RankedTester = rankWith(5, isRangeControl);

export default withJsonFormsCellProps(SliderCell);
